<template>
	<div>
		<header class="header">
			<b-modal
				hide-footer
				hide-header
				:visible="showCountryModal"
				class="country-modal"
				@click="showCountryModal = false"
			>
				<div class="country-modal-wrapper">
					<img
						class="close-button"
						src="../../assets/cross-red-circle.svg"
						alt=""
						@click="showCountryModal = false"
					/>

					<img class="flag" src="../../assets/flag-poland.png" alt="" />

					<h3 class="country-modal-header">
						Jesteś uczniem polskiej szkoły Indigo?
					</h3>

					<p class="country-modal-header">
						Widzimy, że odwiedzasz naszą stronę z Polski. Jeśli uczysz się w
						polskiej szkole Indigo, kliknij “Przejdź na polską platformę”, aby
						przejść na właściwą stronę.
					</p>

					<div class="buttons-block">
						<button
							class="button-custom-outlined"
							@click="showCountryModal = false"
						>
							Pozostań na tej stronie
						</button>

						<a href="https://pl.indigomental.com/" class="button-custom-filled">
							Przejdź na polską platformę
						</a>
					</div>
				</div>
			</b-modal>

			<div class="header-block container">
				<img src="../../assets/logo_en.svg" width="129" alt="Indigo" />
				<div class="buttons">
					<button class="btn btn-cabinet" @click.prevent="openLoginModal">
						<svg
							width="17"
							height="17"
							viewBox="0 0 17 17"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M15.3663 8.97222C15.3041 8.97258 15.2425 8.96067 15.185 8.93717C15.1274 8.91367 15.0751 8.87904 15.031 8.83528L8.28293 2.0825L1.53488 8.83528C1.44454 8.91264 1.32834 8.95306 1.20949 8.94847C1.09064 8.94388 0.977904 8.89462 0.893804 8.81051C0.809704 8.72642 0.760436 8.61368 0.755845 8.49483C0.751255 8.37598 0.79168 8.25978 0.869042 8.16944L7.95238 1.08611C8.04085 0.998158 8.16054 0.948792 8.28529 0.948792C8.41005 0.948792 8.52973 0.998158 8.61821 1.08611L15.7015 8.16944C15.7665 8.23573 15.8105 8.31971 15.828 8.41087C15.8456 8.50203 15.8358 8.59633 15.8001 8.68199C15.7643 8.76765 15.7041 8.84086 15.6269 8.89248C15.5497 8.9441 15.4591 8.97184 15.3663 8.97222Z"
								fill="white"
							/>
							<path
								d="M8.31107 3.67859L2.64441 9.36414V15.1111C2.64441 15.3616 2.74391 15.6018 2.92103 15.7789C3.09815 15.956 3.33837 16.0555 3.58885 16.0555H6.89441V11.3333H9.72774V16.0555H13.0333C13.2838 16.0555 13.524 15.956 13.7011 15.7789C13.8782 15.6018 13.9777 15.3616 13.9777 15.1111V9.33109L8.31107 3.67859Z"
								fill="white"
							/>
						</svg>

						<span class="dashboard-btn">{{ 'Signin' | translate }}</span>
					</button>
					<button
						class="btn-lang"
						@click="showLanguageModal = !showLanguageModal"
					>
						<span class="mr-1">{{ lang }}</span>
						<svg
							width="7"
							height="6"
							viewBox="0 0 7 6"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1 1.5L3.5 4L6 1.5"
								stroke="#646BC0"
								stroke-width="1.5"
							/>
						</svg>
						<div class="lngList" v-if="showLanguageModal">
							<a
								v-for="lng in LANGUAGES"
								:key="lng"
								class="lngListItem"
								href="#"
								@click.stop.prevent="changeLang(lng)"
							>
								{{ lng[1] }}
							</a>
						</div>
					</button>
				</div>
			</div>
		</header>
		<b-modal hide-footer :visible="isLogin" @hide="closeLoginModal">
			<Login />
		</b-modal>
	</div>
</template>
<script>
import Login from './Login'

export default {
	name: 'HeaderAuth',
	props: ['showSignIn'],
	components: { Login },
	data: () => ({
		showLanguageModal: false,
		showCountryModal: false,
		LANGUAGES: [
			['en', 'English'],
			['ru', 'Русский'],
			['ua', 'Українська'],
			['pl', 'Polski'],
			['he', 'עברית'],
			['az', 'Azərbaycan'],
			['hy', 'հայերեն'],
			['ro', 'Română'],
			['fr', 'Français'],
			['es', 'Español'],
			['cs', 'Czech'],
			['de', 'Deutsch'],
			['it', 'Italiano'],
			['tr', 'Türkçe'],
			['el', 'Ελληνικά'],
		],
		lngKeys: [
			'en',
			'ru',
			'ua',
			'pl',
			'he',
			'az',
			'hy',
			'ro',
			'fr',
			'es',
			'cs',
			'de',
			'it',
			'tr',
			'el',
		],
		lang: null,
	}),
	computed: {
		isLogin() {
			return this.$route.path === '/login'
		},
	},
	beforeDestroy() {
		this.$emit('close')
	},
	watch: {
		lang() {
			const isPL = window.location.origin.includes('pl.indigo')

			if (this.lang === 'PL' && !isPL) {
				this.showCountryModal = true
			}
		},
	},
	methods: {
		changeLang(locale) {
			if (!locale) return
			window.localStorage.setItem('defaultLanguage', locale)
			this.showLanguageModal = false
			const keyLocale = locale[0]
			this.$i18n.set(keyLocale)
			this.lang = keyLocale.toUpperCase()
		},

		openLoginModal() {
			this.$router.push('/login')
		},

		closeLoginModal() {
			this.$router.push('/')
		},
	},
	created() {
		const lng = localStorage.getItem('defaultLanguage') || this.$i18n.locale()

		if (lng) {
			const [key] = lng && lng.split(',')
			if (key) {
				this.lang = key.toUpperCase()
				this.$i18n.set(key)
				if (this.$i18n.locale() !== lng) {
					this.$i18n.set(key)
				}
			}
		} else {
			let browserLng =
				window.navigator.userLanguage || window.navigator.language
			if (browserLng && typeof browserLng === 'string') {
				const [lowerKey, upperKey] = browserLng.split('-')
				if (this.lngKeys.includes(lowerKey)) {
					this.lang = upperKey
					return
				}
				this.lang = 'RU'
				this.$i18n.set('ru')
			}
		}

		this.axios({
			method: 'get',
			url: 'geoip/info',
		}).then(response => {
			const isPL = window.location.origin.includes('pl.indigo')

			if (response.data.country === 'Poland' && !isPL) {
				this.showCountryModal = true
			}
		})
	},
}
</script>

<style lang="scss">
.country-modal {
	& .modal {
		& .modal-content {
			max-width: 1300px;

			@media (min-width: 1200px) {
				width: 750px;
				transform: translate(-150px, 100px);
			}
		}
	}
}
</style>

<style scoped lang="scss">
$container-width: 1200px;

.country-modal {
	&-wrapper {
		@media (min-width: 1200px) {
			padding: 10px 60px;
		}
	}

	&-header {
		margin-bottom: 20px;
	}

	&-description {
		margin-bottom: 20px;
	}

	& .flag {
		width: 80px;
		height: auto;
		margin: 30px 0;
	}

	& .buttons-block {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		gap: 5px;
	}

	& .close-button {
		position: absolute;
		right: -13px;
		top: -13px;

		width: 35px;
		height: 35px;

		cursor: pointer;

		transition: all 0.1s ease-in-out;

		&:hover {
			transform: scale(1.1);
		}
	}

	& .button-custom-filled {
		border-radius: 100px;
		height: 55px;
		padding: 15px;
		font-weight: 500;
		font-size: 16px;
		color: #fff;
		min-width: 220px;
		border: none;
		outline: none;
		background: #e0517f;
	}

	& .button-custom-outlined {
		border-radius: 100px;
		height: 55px;
		padding: 15px;
		min-width: 220px;

		font-weight: 500;
		font-size: 16px;
		color: #e0517f;
		// width: 100%;
		border: none;
		outline: none;
		background: transparent;

		border: 1px solid #e0517f;
	}
}

.btn-cabinet {
	background: #646bc0;
	color: #fff;
	display: flex;
	align-items: center;
	padding: 6px 17px;
	transform: scale(1);
	transition: 0.35s ease-in-out;
	border-radius: 100px;

	span {
		margin-top: 5px;
		margin-left: 5px;
	}

	&:hover {
		color: #fff;
		transform: scale(1.05);
	}
}

.lngList {
	background: #fff;
	padding: 20px;
	border-radius: 16px;
	display: flex;
	flex-direction: column;
	position: absolute;
	bottom: -10px;
	transform: translateY(100%) translateX(50%);
	right: 50%;

	@media (max-width: 768px) {
		right: 0;
		transform: translateY(100%) translateX(0);
	}
}

.btn-lang {
	position: relative;
	margin-left: 16px;
	color: #646bc0;
	border: 1px solid #646bc0;
	display: flex;
	background: transparent;
	border-radius: 100px;
	align-items: center;
	min-width: 60px;
	justify-content: center;
	transform: scale(1);
	transition: 0.35s ease-in-out;

	svg {
		flex-shrink: 0;
	}

	&:hover {
		transform: scale(1.05);
	}
}

.buttons {
	display: flex;
}

.header {
	background-color: white;
	padding: 0;
	margin: 0;
	position: relative;
	z-index: 11;
}

.header-block {
	//margin-left: auto;
	//margin-right: auto;
	padding-top: 17px;
	padding-bottom: 17px;
	//max-width: $container-width;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 480px) {
		padding-left: 10px;
		padding-right: 10px;
	}
}

.dashboard-btn {
	@media (max-width: 480px) {
		display: none;
	}
}
</style>
